import React, {Component} from 'react';
import {connect} from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import * as A from '../store/lineageActions';

/**
 * Picks a DD column for a given objectId from /dataDictionary/columns/:objectId.
 * onChange({columnId, columnName, dataType}) — caller stores columnId on the element.
 */
class DdColumnPicker extends Component {
  componentDidMount() {
    if (this.props.objectId) {
      this.props.fetchDdColumns(this.props.objectId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.objectId && prevProps.objectId !== this.props.objectId) {
      this.props.fetchDdColumns(this.props.objectId);
    }
  }

  render() {
    const {value, onChange, objectId, ddColumns, label} = this.props;
    const pickerLabel = label || 'Column';
    const columns = (objectId && ddColumns[objectId]) || [];

    if (!objectId) {
      return (
        <FormControl fullWidth disabled>
          <InputLabel>{pickerLabel}</InputLabel>
          <Select value=""><MenuItem value="">Select a table first</MenuItem></Select>
        </FormControl>
      );
    }

    return (
      <FormControl fullWidth>
        <InputLabel>{pickerLabel}</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => {
            if (!onChange) return;
            const col = columns.find((c) => (c.columnId || c.id) === e.target.value);
            if (col) {
              onChange({
                columnId: col.columnId || col.id,
                columnName: col.columnName || col.name || '',
                dataType: col.dataType || col.type || '',
              });
            } else {
              onChange({columnId: '', columnName: '', dataType: ''});
            }
          }}
          inputProps={{'data-testid': 'dd-column-picker-select'}}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {columns.map((c) => {
            const id = c.columnId || c.id;
            const name = c.columnName || c.name || id;
            const type = c.dataType || c.type || '';
            return (
              <MenuItem key={id} value={id}>
                {name}{type ? ` : ${type}` : ''}
              </MenuItem>
            );
          })}
        </Select>
        {columns.length === 0 && objectId && <FormHelperText>No columns found</FormHelperText>}
      </FormControl>
    );
  }
}

const mapStateToProps = (state) => ({ddColumns: state.lineageReducer.ddColumns});

export default connect(mapStateToProps, {fetchDdColumns: A.fetchDdColumns})(DdColumnPicker);
